GameView = require "views/base/game"
Device   = require("lib/device")

class TapInOrderView extends GameView
  template: require("./template")

  events: ->
    "iostap .tappy":    "tappyTouch"
    "iostap .btn-done": "endGame"

  serialize: ->
    data = super
    data.tappies = _.chain(data.list)
      .filter((el) -> el)
      .map (el, i) ->
        image: el
        trueIndex: i
      .shuffle().value()

    length  = data.tappies.length
    useGrid = length >= 4

    data.dimensions =
      width:
        "#{if useGrid then 50 else 100}%"
      height:
        "#{100 / (if useGrid then (length + length % 2) / 2 else length)}%"


    return data

  show: ->
    super
    @rejectIncorrectAnswer()
    @initTapState()

    @setEl @findOne(".tappies-parent"), "tappiesParent"
    @setEl @findAll(".tappy"), "tappies"
    @setEl @findOne(".title"), "title"
    @setEl @findAll(".number"), "numbers"
    @refreshTappy()

    @enterGame()

  onResize: ->
    @setTappyHeight()

  refreshTappy: ->
    for el, i in @getEl "tappies"
      el.classList.add("no-delay")
    @listenTo this, "resize", @onResize
    @setTappyHeight()

  onRefresh: ->
    super
    @fillTaps()

  rejectIncorrectAnswer: ->
    @reject = @options.data.reject

  setTappyHeight: ->
    parent = @getEl("tappiesParent")
    height = parent.offsetHeight

    if Device.breakpoint(["xs", "sm"])
      height -= @getEl("title").offsetHeight

    if @getEl("tappies").item(0)?
      @getEl("tappies").item(0).parentNode.style.height = "#{height}px"
    else
      return

  initTapState: ->
    @tapsSoFar = []

  isCorrectSoFar: ->
    orderReducer = (order, tap, i) -> order and tap is i.toString()
    return @tapsSoFar.reduce orderReducer, true

  isCorrect: ->
    @initTapState() if not @tapsSoFar?
    return @isCorrectSoFar() and @tapsSoFar.length is @options.data.list.length

  fillTap: (num) ->
    parent   = num.parentNode.parentNode.parentNode
    arrayPos = @tapsSoFar.indexOf num.dataset.trueIndex

    if arrayPos > -1
      num.innerHTML = arrayPos + 1
      parent.classList.add "active"
      parent.dataset.filledIndex = arrayPos
    else
      num.innerHTML = ""
      parent.classList.remove "active"
      parent.dataset.filledIndex = ""

  fillTaps: ->
    @fillTap num for num, i in @getEl("numbers")

  showAnswer: ->
    if @isCorrect()
      @el.classList.add "correct-#{@isCorrect()}"
      @el.classList.remove "correct-#{not @isCorrect()}"
    else
      for el, i in @getEl "tappies"
        if el.dataset.filledIndex isnt el.dataset.trueIndex
          el.classList.add "incorrect"
        else
          el.classList.remove "incorrect"

  keepTapsBefore: (index) ->
    indexOfTap = @tapsSoFar.indexOf(index)
    if indexOfTap > 0
      @tapsSoFar = @tapsSoFar.slice(0, indexOfTap) if indexOfTap > -1
    else if indexOfTap is 0
      @tapsSoFar = []

  onRejected: (e) ->
    @currentTappy.classList.add "incorrect"
    window.setTimeout ( =>
      @currentTappy.classList.remove "incorrect"
    ), 400

  tappyTouch: (e) ->
    @currentTappy = e.currentTarget
    touchedIndex = e.currentTarget.dataset.trueIndex
    touchedOrigIndex = e.currentTarget.dataset.originalIndex
    alreadyTapped = @tapsSoFar.indexOf(touchedIndex) isnt -1
    if alreadyTapped
      @keepTapsBefore touchedIndex
    else
      @tapsSoFar.push touchedIndex

    if @isCorrectSoFar() or not @reject
      @fillTaps @getEl("numbers")[e.currentTarget.dataset.originalIndex]
    else
      @keepTapsBefore touchedIndex
      @onRejected() if @reject

    @setState("touched")

  answerDetails: ->
    questions    = @options.metadata?.questions or []
    return [] unless questions.length > 0
    question = questions[0]

    isCorrect = @isCorrect()
    answer = _.find question.answers, (a) -> a.correct is isCorrect
    answerElements = _.map @tapsSoFar, (idx) =>
      _.find @getEl("tappies"), (tappy) ->
        @$(tappy).data("true-index") is Number(idx)
    answerContent = _.map answerElements, (el) -> @$(el).data("content")
    answer.content = answerContent.join(", ")

    details = question: questions[0].question, answer: answer

    [ details ]

  endGame: ->
    super

    @submit()

module.exports = TapInOrderView
